/**
 * @file コンポーネント：段落 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledParagraph, StyledParagraphContainer } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledParagraph ref={props.refParagraph}>
            <StyledParagraphContainer
                dangerouslySetInnerHTML={{ __html: props.text }}
                data-font-size={props.fontSize}
                data-on-color={props.onColor}
                data-paragraph-type={props.paragraphType}
                data-text-align={props.textAlign}
                ref={props.refParagraphContainer}
            />
        </StyledParagraph>
    );
};
